module.exports = __webpack_public_path__ + "static/laptop-basic.59972b4c-3f6520a5a71e27ac359bf50aa796152c.png";